import { Route } from '@angular/router';
import { LoginComponent } from './ui/login/login.component';
import { RegisterComponent } from './ui/register/register.component';
import { b2cSignupGuard } from '../../core/guards/b2c-signup.guard';

const authRoutes: Route[] = [
  {
    // Links from the public site point at /auth/*. Registration serves the component
    // directly rather than redirecting, because a string redirectTo drops the query
    // string and ?role= would be lost.
    path: 'auth',
    children: [
      { path: '', redirectTo: '/', pathMatch: 'full' },
      { path: 'login', redirectTo: '/', pathMatch: 'full' },
      { path: 'login-failed', redirectTo: '/login-failed', pathMatch: 'full' },
      {
        path: 'register',
        component: RegisterComponent,
        canActivate: [b2cSignupGuard],
      },
    ],
  },
  {
    path: '',
    children: [
      {
        path: '',
        component: LoginComponent,
      },
      {
        path: 'login-failed',
        component: LoginComponent,
      },
      {
        path: 'register',
        component: RegisterComponent,
        canActivate: [b2cSignupGuard],
      },
    ],
  },
];

export default authRoutes;
